import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Activity: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'M22 12h-4l-3 9L9 3l-3 9H2' }]],
];

export default Activity;
